import React from 'react'
import ContactNav from '../Components/ContactNav'
import ContactSection from '../Components/ContactSection'



function Contact() {
  return (
    <>
    <ContactNav />
    <ContactSection />
    </>
  )
}

export default Contact